import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Avatar, Stack, Menu, MenuItem, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../images/logo.svg";

export default function Banner({ handleLogOut, userData, handleOpenOrgDialog, hasMultipleOrgs }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLogOutClick = () => {
    handleClose();
    handleLogOut();
  };
  
  const handleSwitchOrgClick = () => {
    handleClose();
    handleOpenOrgDialog();
  };

  const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  
  const fullName = userData?.firstName && userData?.lastName 
    ? `${capitalize(userData.firstName)} ${capitalize(userData.lastName)}`
    : capitalize(userData?.firstName || userData?.lastName || "N/A");
  
  return (
    <AppBar position="static" sx={{ bgcolor: "primary.main", boxShadow: "none" }}>
      <Toolbar sx={{ justifyContent: "space-between", px: { xs: 1, md: 3 }, py: 3 }}>
        <img src={logo} alt="Pearson Logo" style={{ height: "24px" }} />
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: "primary.contrastText", color: "primary.main", width: 48, height: 48 }}>
            <PersonIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Typography variant="h6" sx={{ color: "primary.contrastText", fontSize: "18px" }}>
            {fullName}
          </Typography>
          <IconButton
            aria-controls={open ? "user-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleMenuClick}
            sx={{ color: "primary.contrastText" }}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: { 
                minWidth: '200px',
                mt: 0.5
              }
            }}
          >
            {hasMultipleOrgs && (
              <MenuItem onClick={handleSwitchOrgClick}>Switch Organization</MenuItem>
            )}
            <MenuItem onClick={handleLogOutClick}>Log Out</MenuItem>
          </Menu>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}